import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@hyperhedge/ui/styles";
import "@hyperhedge/ui/tokens";
import "./styles.css";
import { Providers } from "./providers";
import { App } from "./app";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("#root not found");

createRoot(rootEl).render(
  <StrictMode>
    <Providers>
      <App />
    </Providers>
  </StrictMode>,
);
